import BaseApi from "@/api/baseApi";

export default {
  addOrUpdate(form) {
    return BaseApi.post('/api-master-data/v1/manual-reasons', form);
  },
  fetch() {
    return BaseApi.get('/api-master-data/v1/manual-reasons');
  },
  fetchById(id) {
    return BaseApi.get(`/api-master-data/v1/manual-reasons/${id}`);
  },
  remove(id) {
    return BaseApi.delete(`/api-master-data/v1/manual-reasons/${id}`);
  }
}
